export const styles = () => ({
  container: {
    minWidth: 300
  }
})



// WEBPACK FOOTER //
// ./src/components/EnhancedModal/styles.js